export const orderStatusCase = (
    orderStatus: 'CANCELED' | 'CONFIRMED' | 'PAID' | 'PENDING_CANCEL' | 'READY' | 'WAIT',
    shippingStatus?: 'DELIVERED' | 'IN_DELIVERY' | 'READY'
) => {
    switch (orderStatus) {
        case 'CANCELED':
            return '주문취소'
        case 'CONFIRMED':
            return '구매확정'
        case 'WAIT':
            return '결제대기'
        case 'PAID':
            switch (shippingStatus) {
                case 'IN_DELIVERY':
                    return '배송중'
                case 'DELIVERED':
                    return '배송완료'
                default:
                    return '상품 준비 중'
            }

    }
}

export const requestStatusCase = (
    requestType: 'EXCHANGE' | 'RETURN',
    requestStatus: 'COMPLETED' | 'DELIVERED' | 'IN_DELIVERY' | 'PENDING' | 'READY' | 'READY_DELIVERY' | 'REFUNDED' | 'RETURNED' | 'CANCELED'
) => {
    switch (requestStatus) {
        case "READY":
            return '결제 대기'
        case 'PENDING':
            return requestType === 'EXCHANGE' ? '교환 신청' : '반품 신청'
        case "RETURNED":
            return '수거 완료'
        case "READY_DELIVERY":
            return '택배 회수 접수 완료'
        case 'DELIVERED':
            return '배송 완료'
        case 'REFUNDED':
            return '환불 완료'
        case 'IN_DELIVERY':
            return '배송중'
        case 'COMPLETED':
            return '구매 확정'
        case 'CANCELED':
            return requestType === 'EXCHANGE' ? '교환 취소' : '반품 취소'
    }
}
